import styled from '../../config/theme'

const Container = styled.div`
  position: relative;
`

const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 36px;

  > h2 {
    margin: 0;
    margin-right: 36px;
    flex: 1;
  }
`

const Content = styled.div<{ open: boolean, small: boolean }>`
  display: flex;

  position: fixed;
  z-index: ${props => props.open ? props.theme.zIndex.backdropContent : -1};
  left: 0;
  right: 0;
  top: ${props => props.small ? '30vh' : '10vh' };

  flex-direction: column;

  min-height: ${props => props.small ? 'unset' : '80vh' };
  max-height: ${props => props.small ? '70vh' : '80vh' };
  width: ${props => props.small ? '500px' : '800px' };
  margin: auto;

  border-radius: 5px;
  background: white;
  border: 1px solid ${props => props.theme.color.lightGray};

  > * {
    margin-bottom: 5px;
  }

  @media screen and (max-width: ${props => props.theme.mediaQueries.modal}) {
    top: ${props => props.small ? '20vh' : '10vh' };
    left: ${props => props.small ? '20vw' : '0' };
    max-height: unset;
    width: unset;
    bottom: ${props => props.small ? 'unset' : '10vh' };
    right: ${props => props.small ? '20vw' : '0' };
  }
`

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);

  z-index: ${props => props.theme.zIndex.backdrop};
`

export {
  Header,
  Container,
  Content,
  Backdrop,
}
